import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const api = `salesreport`;
export default {
    salesOrderByCampaign(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','CampaignKey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesOrderByCampaign${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesOrderByCampaignExport2Excell(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl1', 'tgl2','CampaignKey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesOrderByCampaignExport2Excell${str}`;
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_order_by_campaign.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                    // window.location.assign(url);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesBycategory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','kategori'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesBycategory${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesBycategoryExport2Excell(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl1', 'tgl2','kategori'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesBycategoryExport2Excell${str}`;
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_by_category.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                    // window.location.assign(url);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesBybrand(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','brand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesBybrand${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesBybrandExport2Excell(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl1', 'tgl2','brand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesBybrandExport2Excell${str}`;
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_by_brand.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                    // window.location.assign(url);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesByproduct(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','itemno', 'itemname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesByproduct${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesByproductExport2Excell(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl1', 'tgl2','itemno', 'itemname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/salesByproductExport2Excell${str}`;
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_by_product.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                    // window.location.assign(url);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
            
    topSalesOrderByCustomer(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'peringkat','tahun','customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/topSalesOrderByCustomer${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    topSalesOrderByCstExport2Excell(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'peringkat','tahun','customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${api}/topSalesOrderByCstExport2Excell${str}`;
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `top_sales_order_by_${obj.customer_group}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                    // window.location.assign(url);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // topSalesOrderByAgency(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','customer_id'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${api}/topSalesOrderByAgency${str}`;
    //             const { data } = await axios.get(url);
    //             const { meta, list } = data;
    //             obj.total = meta.total;
    //             resolve(list);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    // topSalesOrderByAdvertiser(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','customer_id'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${api}/topSalesOrderByAdvertiser${str}`;
    //             const { data } = await axios.get(url);
    //             const { meta, list } = data;
    //             obj.total = meta.total;
    //             resolve(list);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
}